<div class="container">
    <div class="container-body">
        <div class="example-card">

            <mat-card>
                <mat-card-header>
                    <mat-card-title>{{recruiter.name | titlecase}} {{recruiter.lastname |titlecase}}
                    </mat-card-title>
                    <mat-card-subtitle>Reclutador</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <mat-form-field appearance="fill" style="width: 100%;">
                        <mat-label>Ingrese un periodo de tiempo</mat-label>
                        <mat-date-range-input  [formGroup] = "range" [rangePicker]="picker">
                            <input matStartDate formControlName="start" placeholder="Fecha de inicio">
                            <input matEndDate formControlName="end" placeholder="Fecha final">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                        
                        <mat-error *ngIf="range.controls.start.hasError('matDatepickerParse')">Fecha de inicio inválida</mat-error>
                        <mat-error *ngIf="range.controls.end.hasError('matDatepickerParse')">Fecha final inválida</mat-error>
                    </mat-form-field>

                </mat-card-content>
                <mat-card-actions>
                    <button mat-button (click)="loadInfo()">Cargar</button>
                </mat-card-actions>
            </mat-card>

        </div>

        <div class="evaluations" *ngIf = "!noInfo">
            <div>

                <mat-card>
                    <mat-card-header>
                        <div mat-card-avatar></div>
                        <mat-card-title>Resumen de evaluaciones
                        </mat-card-title>
                        <mat-card-subtitle></mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>


                        <table mat-table [dataSource]="statistics" class="mat-elevation-z8">

                            <!--- Note that these columns can be defined in any order.
                          The actual rendered columns are set as a property on the row definition" -->

                            <!-- Position Column -->
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef> Estadística </th>
                                <td mat-cell *matCellDef="let statistic"> {{statistic.name}}</td>

                            </ng-container>

                            <!-- Position Column -->
                            <ng-container matColumnDef="value">
                                <th mat-header-cell *matHeaderCellDef> Valor </th>
                                <td mat-cell *matCellDef="let statistic"> {{statistic.value}} </td>

                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                        </table>


                    </mat-card-content>
                    <mat-card-actions>
                    </mat-card-actions>
                </mat-card>

            </div>
        </div>
    </div>
</div>